import omit from 'lodash.omit'
import styled from 'styled-components'

const { CLIENT_CDN_BASE_URL } = global.process.env

const _CDNAsset = (props) => {
  const { directory, filename } = props

  return (
    <img
      {...omit(props, ['directory', 'filename'])}
      src={`${CLIENT_CDN_BASE_URL}/${directory}/${filename}`}
      alt={filename}
    />
  )
}

export const CDNAsset = styled(_CDNAsset)``
